module.exports = __webpack_public_path__ + "img/titleIcon4.1bdaa86a.png";